var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.plc || _vm.$t(`message.services`),"filterable":"","clearable":"","size":_vm.size},on:{"input":_vm.dispatch}},_vm._l((_vm.services),function(service){return _c('el-option',{key:service.id,attrs:{"label":service.name,"value":service.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }